import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {User} from '../models/user';
import {GlobalConstantsComponent} from '../shared/global-constants/global-constants.component';
import {PlatformService} from '../services/platform-service.service';
import {SocialAuthService} from '@abacritt/angularx-social-login';

@Injectable({providedIn: 'root'})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  private apiUrl = GlobalConstantsComponent.apiURL;

  constructor(
    private http: HttpClient,
    private platformService: PlatformService,
    private socialAuthService: SocialAuthService,
  ) {
    if (platformService.isBrowserPlatform()) {
      this.currentUserSubject = new BehaviorSubject<User>(
        JSON.parse(localStorage.getItem('currentUser'))
      );
      this.currentUser = this.currentUserSubject.asObservable();
    }

  }

  public get currentUserValue(): User {
    if(this.platformService.isBrowserPlatform()) {
      return this.currentUserSubject.value;
    }
  }

  login(email, password, slug, avatar?) {
    if(this.platformService.isBrowserPlatform()) {
      return this.http
        .post<any>(`${this.apiUrl}login`, {email, password, slug, avatar})
        .pipe(
          map((response) => {
            if (response.status == 'error') {
              return response;
            }
            localStorage.setItem('currentUser', JSON.stringify(response.data));
            this.currentUserSubject.next(response.data);
            return response;
          })
        );
    }
  }

  logout() {
    if (this.platformService.isBrowserPlatform()) {
      localStorage.removeItem('currentUser');
      localStorage.removeItem('userSession');
      this.currentUserSubject.next(null);
      this.socialAuthService.authState.subscribe((user) => {
        if (user) {
          const signOutPromise = this.socialAuthService.signOut();
        }
      });
    }
  }

  public checkIfAdmin(): Observable<boolean> {
    return this.http.get(`${this.apiUrl}l-cia/`).pipe(map(response => response && response['status']));
  }
}
